import client from './client';

export const login = (email, password) =>
  client.post('/api/auth/login', { email, password });

export const getMe = () =>
  client.get('/api/auth/me');

export const logout = () =>
  client.post('/api/auth/logout');

export const getAdminInvite = (token) =>
  client.get(`/api/auth/admin-invite/${token}`);

export const acceptAdminInvite = (payload) =>
  client.post('/api/auth/accept-admin-invite', payload);

